import en from 'src/components/i18nProvider/en';
import { permissionCode } from '..';
import { COLUMN_WIDTH } from '../../../../constants/ColumnWidth';
import { usePermission, useTranslation } from '../../../../hooks';
import { useGenGridCol } from '../../../../utils/ComponentHelper';
import { TableColumnKey } from '../types/Table';
import { GridColumnHeaderParams } from '@mui/x-data-grid';
import { useAppSelector } from 'src/reducer/hooks';
import { selectProfile } from 'src/reducer/profileSlice';

interface IProps {
  renderUsageDetailsCell: (props: any) => JSX.Element;
}

const useTableColumns = (props: IProps) => {
  const { renderUsageDetailsCell } = props;

  const { hasPermission } = usePermission();
  const { t } = useTranslation('referralCode');

  const { lang } = useAppSelector(selectProfile);

  const isUsageDetailsColVisible = hasPermission(permissionCode.UsageDetails);

  const renderGmt8InfoHeader = (params: GridColumnHeaderParams) => {
    const headerText = params.colDef.headerName;

    if (!headerText) {
      return headerText;
    }

    const openParenthesis = lang === 'en' ? '(' : lang === 'zh_cn' ? '（' : '';

    const splittedHeaderTexts = headerText.split(openParenthesis);

    const mainHeaderText = splittedHeaderTexts[0].trim();

    const gmtInfoText = splittedHeaderTexts[1] ? openParenthesis + splittedHeaderTexts[1] : '';

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          lineHeight: '1.5',
        }}
      >
        <div>{mainHeaderText}</div>
        <div>{gmtInfoText}</div>
      </div>
    );
  };

  const columns = [
    useGenGridCol(TableColumnKey.UsageDetails, { renderCell: renderUsageDetailsCell }),
    useGenGridCol(TableColumnKey.ProgramName),
    useGenGridCol(TableColumnKey.CodeReferenceName, { minWidth: 140 }),
    useGenGridCol(TableColumnKey.ReferralCode, { minWidth: 140 }),
    useGenGridCol(TableColumnKey.DistributorAgentId, { minWidth: 140 }),
    useGenGridCol(TableColumnKey.NumberOfUses),
    useGenGridCol(TableColumnKey.MaximumNumberOfUses, {
      renderCell: (params) =>
        params.value === en.referralCode.unlimited ? t('unlimited') : params.value,
    }),
    useGenGridCol(TableColumnKey.StartDate, {
      minWidth: 130,
      renderHeader: renderGmt8InfoHeader,
    }),
    useGenGridCol(TableColumnKey.EndDate, {
      minWidth: 130,
      renderHeader: renderGmt8InfoHeader,
    }),
    useGenGridCol(TableColumnKey.ReferralCodeStatus),
    useGenGridCol(TableColumnKey.ConsumedSupportedSystem, { minWidth: 150 }),
    useGenGridCol(TableColumnKey.Source),

    useGenGridCol(TableColumnKey.KycLevel),
    useGenGridCol(TableColumnKey.VipLevel),
    useGenGridCol(TableColumnKey.IdvMethod),

    useGenGridCol(TableColumnKey.CreationTime, {
      minWidth: COLUMN_WIDTH.CreatedDate.MinWidth,
    }),
    useGenGridCol(TableColumnKey.LastModifiedTime, {
      minWidth: COLUMN_WIDTH.LastModifiedDate.MinWidth,
    }),
  ];

  return columns.filter(
    ({ field }) => field !== TableColumnKey.UsageDetails || isUsageDetailsColVisible
  );
};

export default useTableColumns;
